import { Checkbox } from '../../../cdl/Checkbox/Checkbox';
import { formatCompanyName } from '../../../common/helpers/formatCompanyName.helper';
import { Box } from '../../../common/ui/Box';
import type { DemandFleetCompany } from '../../types/DemandFleetCompany';
import { DemandHistoricalVolume } from '../DemandHistoricalVolume';

interface FleetCompanyRowProps {
    company: DemandFleetCompany;
    isVolumeLoading: boolean;
    isSelected: boolean;
    onToggleCompanySelection: (company: DemandFleetCompany) => void;
    showHistoricalData: boolean;
}

export const FleetCompanyRow = ({
    company,
    isVolumeLoading,
    isSelected,
    onToggleCompanySelection,
    showHistoricalData,
}: FleetCompanyRowProps) => {
    return (
        <Box
            display="grid"
            gridTemplateColumns={showHistoricalData ? 'minmax(0, 1fr) 140px' : 'minmax(0, 1fr)'}
            columnGap={12}
            alignItems="center"
            paddingX={8}
            paddingY={8}
        >
            <Checkbox
                checked={isSelected}
                label={formatCompanyName({ company }) ?? company.name}
                truncateLabel
                onChange={() => onToggleCompanySelection(company)}
            />
            {showHistoricalData ? (
                <DemandHistoricalVolume historicalVolume={company.historicalVolume} isLoading={isVolumeLoading} />
            ) : null}
        </Box>
    );
};
